namespace TabAurous.Finance {

    @Serenity.Decorators.registerEditor()
    export class PaymentModesEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addOption("Cash", "Cash");
            this.addOption("Cheque", "Cheque");

        }
    }
}